<template>

  <div class="mt-5 w-full text-neutral-500 text-sm">
      <p class="mb-4">
        {{ $t('modal.change_ticket_holder.description') }}
      </p>
      <ol class="change_ticket_holder mb-4 list-decimal list-inside"
          v-html="t('modal.change_ticket_holder.list')"/>
      <p class="mb-4">
        {{ $t('modal.change_ticket_holder.note') }}
      </p>
      <hr class="w-full border-neutral-200 my-5">
      <p class="text-xs" v-text="t('common.last_updated', [dayjs('03/09/2022').format('MMM D, YYYY')])"></p>
  </div>

</template>

<script setup lang="ts">
import dayjs from "dayjs"
const {t} = useI18n()
</script>
<style scoped>
ol.change_ticket_holder :deep(li) {
  @apply mb-4
}
</style>
